import React, { PureComponent, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import xml from 'react-syntax-highlighter/dist/esm/languages/hljs/xml';
import js from 'react-syntax-highlighter/dist/esm/languages/hljs/javascript';
import atomOneDark from 'react-syntax-highlighter/dist/esm/styles/hljs/atom-one-dark-reasonable';
import pretty from 'pretty';
import Accordion from '../../src/components/Accordion/Accordion';

SyntaxHighlighter.registerLanguage('javascript', js);
SyntaxHighlighter.registerLanguage('xml', xml);

SourceCode.propTypes = {
  children: PropTypes.node,
  expanded: PropTypes.bool,
  language: PropTypes.string,
  querySelector: PropTypes.string,
  showHeader: PropTypes.bool,
  title: PropTypes.string,
};
SourceCode.defaultProps = {
  language: 'xml',
  title: 'Generated HTML',
  showHeader: true,
};

export default function SourceCode(props) {
  const { children, language, showHeader, title } = props;
  const [isExpanded, setIsExpanded] = useState(false);
  const [html, setHtml] = useState('');

  useEffect(() => {
    if (isExpanded) {
      updateSource();
    }
  });

  const onClick = () => {
    setIsExpanded(!isExpanded);
    if (isExpanded) {
      updateSource();
    }
  };

  const updateSource = () => {
    const { querySelector } = props;
    const el = document.querySelector(querySelector);

    if (el) {
      setTimeout(() => {
        const raw = el.outerHTML
          .toString()
          .replace(/<svg .*?<\/svg>/g, '<svg> </svg>');
        const html = pretty(raw, { ocd: true });

        setHtml(html);
      }, 1);
    }
  };

  return (
    <Accordion
      className='source-code'
      title={title}
      expanded={!showHeader || isExpanded}
      onClick={onClick}
      showHeader={showHeader}
    >
      {(!showHeader || isExpanded) && (
        <SyntaxHighlighter language={language} style={atomOneDark}>
          {children && children.length > 0 ? children.toString() : html}
        </SyntaxHighlighter>
      )}
    </Accordion>
  );
}
